import { render } from "./TermsOfServices.vue?vue&type=template&id=2a4c7e2a"
import script from "./TermsOfServices.vue?vue&type=script&lang=js"
export * from "./TermsOfServices.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/plaintes.getourvoice.com/releases/72929466/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__